<template>
  <ReactSiteFrame :src="src" />
</template>
<script>
import ReactSiteFrame from '../components/react/iframe'

export default {
  name: 'TeamReact',
  components: {
    ReactSiteFrame
  },
  data() {
    return {
      src: '/view/team'
    }
  }
}
</script>
